import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UZURV_REST_CONFIGURATION, UzurvRestConfiguration, UzurvRestService } from '@uzurv/http';
import { Deserialize, Serialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CreateRideSubscriptionRequest, RideSubscriptionDetail } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class RideSubscriptionService extends UzurvRestService {
  readonly resourceUrl = 'rideSubscriptions/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Find a ride subscription by id
   *
   * @param rideSubscriptionId
   * @returns
   */
  findById(rideSubscriptionId: number): Observable<RideSubscriptionDetail> {
    return this.get<RideSubscriptionDetail>(`${this.resourceUrl}${rideSubscriptionId}`).pipe(
      map(response => Deserialize(response, RideSubscriptionDetail))
    );
  }

  /**
   * Saves a new ride subscription.
   *
   * @param itinerary
   * @param startDate
   * @param endDate
   * @param days
   * @returns
   */
  saveRideSubscription(rideSubscription: CreateRideSubscriptionRequest): Observable<RideSubscriptionDetail> {
    return this.post<CreateRideSubscriptionRequest>(this.resourceUrl, Serialize(rideSubscription)).pipe(
      map(response => Deserialize(response, RideSubscriptionDetail))
    );
  }

  /**
   * Searches for ride subscriptions matching
   * - Rider First Name
   * - Rider Last Name
   * - Rider Full Name
   * - Rider Email Address
   * - Rider Phone Number
   *
   * @param searchString
   * @param pageNumber
   * @param pageSize
   * @permission trip_search
   */
  search(searchString: string, pageNumber, pageSize): Observable<Array<RideSubscriptionDetail>> {
    return this.get<Array<RideSubscriptionDetail>>(`search/${this.resourceUrl}`, {
      searchString: searchString,
      pageNumber: pageNumber,
      pageSize: pageSize
    }).pipe(map(response => Deserialize(response, RideSubscriptionDetail)));
  }
}
